import { FC, ReactNode } from 'react';

import { useFullscreenElement } from '../FullscreenProvider';

import classes from './FullscreenContainer.module.scss';

export interface FullscreenContainerProps {
  children?: ReactNode;
}

export const FullscreenContainer: FC<FullscreenContainerProps> = ({
  children,
}) => {
  const { setFullscreenElement, fullscreen } = useFullscreenElement();

  return (
    <div
      className={classes.container}
      ref={setFullscreenElement}
      data-is-fullscreen={fullscreen}
    >
      {children}
    </div>
  );
};
